<template>
  <div class="w-full bg-gray-50 overflow-y-auto" :class2="{ 'w-48': items?.length < 2, 'w-48': items?.length == 2, 'w-48': items?.length > 2 }">
    <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg  ">
      <h3 class="font-bold text-gray-900 ">Détails</h3>
    </div>
    <div class="px-2 py-2 flex flex-col w-full border-b border-b-gray-300" v-for="cell in items" :key="cell.id">
      <div class="text-sm font-normal h-full flex flex-row items-center px-1" v-if="cell?.temperature?.value != undefined">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-temperature-quarter" />
        </div>
        <span>Température :</span> &MediumSpace;
        <span class="font-semibold">{{ formatTemperature(cell?.temperature?.value) }} {{ cell?.temperature?.unit }}</span>
      </div>

      <div class="text-sm font-normal h-full flex flex-row items-center px-1" v-if="cell?.humidity_rate?.value != undefined">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-droplet" />
        </div>

        <span>Taux Humidité :</span> &MediumSpace;
        <span class="font-semibold">{{ cell?.humidity_rate?.value }} {{ cell?.humidity_rate?.unit }}</span>
      </div>

      <div class="text-sm font-normal h-full flex flex-row items-center px-1" v-if="cell?.reason_label != undefined">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-temperature-quarter" />
        </div>
        <span>Pas de prise de température :</span> &MediumSpace;
      </div>

      <div class="text-sm font-normal h-full flex flex-row items-center px-1" v-if="cell?.reason_label != undefined">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-message" />
        </div>

        <span class="font-semibold">{{ cell?.reason_label }}</span>
      </div>

      <div class="text-sm mt-2 font-normal h-full flex flex-row items-center px-1">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-clock"></i>
        </div>

        <span>Heure du relevé :</span> &MediumSpace;
        <span class="font-semibold">{{ formatDateTime(cell?.done_at) }}</span>
      </div>
      <div class="text-sm font-normal flex flex-row items-center px-1 h-full">
        <div class="flex justify-center w-10 pr-2">
          <i class="fa-regular fa-user" />
        </div>
        <span>Relevé par :</span>&MediumSpace;<span class="font-semibold">{{ cell?.actor_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileColDisplayTemperatureHumidity",
  components: {},
  methods: {
    formatTemperature: function (value) {
      if (value == undefined) return "";
      if (value == "") return "";
      if (value == "null") return "";
      if (value == "--") return "";

      let valueF = parseFloat(value);

      return valueF.toFixed(2);
    },
    formatDateTime: function (date) {
      if (date == undefined) return "";
      if (date == "") return "";
      if (date == "null") return "";
      if (date == "--") return "";

      var myDate = new Date(date);

      const options = { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" };
      let formatteddate = myDate.toLocaleString("fr-FR", options);

      //  return date
      return formatteddate;
    },
  },
  props: {
    items: Array,
  },
  data() {
    return {};
  },
};
</script>
